import { render, staticRenderFns } from "./workDetails.vue?vue&type=template&id=64ef3ddd&scoped=true&"
import script from "./workDetails.vue?vue&type=script&lang=js&"
export * from "./workDetails.vue?vue&type=script&lang=js&"
import style0 from "./workDetails.vue?vue&type=style&index=0&id=64ef3ddd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef3ddd",
  null
  
)

export default component.exports